<template>
    <div>
        <section :class="{['p-homework-items -'+ subjectName]:true}" :id="`homeworklist-${homework.id}`">
            <input type="checkbox" v-model="isOpenLocal" :id="`homework-${homework.id}`" class="c-parts-accordion-input" @change="open()">
            <label :for="`homework-${homework.id}`" class="c-parts-accordion-label" @click="playButtonSound()" :name="getSentryHwAccordionName"></label>
            <div class="p-homework-items__structure p-homework-items__complete">
                <div class="p-homework-items__overview">
                    <div class="p-homework-items__status">
                        <p :class="{['p-homework-status -'+ homework_status_class[homework.homework_status]]: true}">{{homework_status_name[homework.homework_status]}}</p>
                        <p class="p-homework-items__left" v-if="(homework.homework_status === getHomeworkProgress.NOTSTARTED || homework.homework_status === getHomeworkProgress.INPROGRESS) && isCurrent" v-html="remainingTime(homework.end_datetime)"></p>
                        <div class="p-homework-items__period">
                            <div><em class="num">{{ getMonth(homework.start_datetime) }}</em>月<em class="num">{{ getDate(homework.start_datetime) }}</em>日({{ getDay(homework.start_datetime) }})<span class="time">{{ getTime(homework.start_datetime) }}</span></div>
                            <span class="from-to">〜</span>
                            <div><em class="num">{{getMonth(homework.end_datetime)}}</em>月<em class="num">{{ getDate(homework.end_datetime) }}</em>日({{ getDay(homework.end_datetime) }})<span class="time">{{ getTime(homework.end_datetime) }}</span></div>
                        </div>
                    </div>
                    <div class="p-homework-items__subject">
                        <h2 class="p-homework-items__subject-title">{{ subjectFieldName }}<span class="num" v-if="subjectFieldName ==='歴史' && academicYear >= 2">2・3</span><span class="num" v-else-if="subjectFieldName !== '公民'">{{ academicYear }}</span></h2>
                        <p class="p-homework-items__description">{{ homework.homework_title }}</p>
                    </div>
                </div>
                <div class="p-homework-items__stamp">
                    <div :id="`stamp-${homework.id}`" 
                        :class="{'p-homework-items__stamp-seal': true, 'p-homework-items__stamp-seal--complete': true, 'is-completed': homework.id !== homeworkStore.homeworkAnimationIds[homework.id] || !isCurrent || homeworkStore.learningHomeworkStatus === 0 || homeworkStore.learningHomeworkStatus >= getHomeworkProgress.COMPLETEDWITHIN}" 
                        v-if="homework.homework_status >= getHomeworkProgress.COMPLETEDWITHIN">
                        <img src="@/styles/img/common/img_stamp_complete.svg" alt="complete">
                    </div>
                </div>
            </div>
            <button type="button" class="c-button-white p-homework-items__button c-parts-accordion-hidden">
                <span class="label">内容を表示</span>
            </button>  
            <div class="p-homework-items__detail c-parts-accordion-content">
                <button type="button" class="c-button-white p-homework-items__button -close-icon">
                    <span class="label">内容を閉じる</span>
                </button>
                <div class="p-homework-items__message">
                    <h3 class="p-homework-items__problem-status">
                        <p class="c-parts-pin -large">{{ achievement_condition[homework.achievement_condition] }}</p>
                        <p class="c-parts-pin -large" v-if="homework.relearning_required">学習済みでも、もう一度取り組もう</p>
                    </h3>
                    <div class="p-homework-items__message-frame">
                        <p class="title">先生からのメッセージ</p>
                        <p class="text">{{ homework.message.substring(0, 100) }}</p>
                    </div>
                </div>
                <template v-for="part in getParts">
                    <div class="p-homework-items__unit" v-if="subjectName === 'rika'">
                        <span class="c-parts-label -homework-large">{{ part.index_label }}</span>
                        <div class="title">
                            <markdown-view :rawText="part.title" :souruby="accountStore.isSouruby"></markdown-view>                       
                        </div>
                    </div>
                    <div class="c-question-block c-question-block--detail" v-for="chapter in part.chapters">
                        <label :for="`homework-${homework.id}-${chapter.id}`" class="c-parts-accordion-label" @click="playButtonSound()"></label>
                        <div class="c-question-block__inner">
                            <div class="c-question-block__titleBox">
                                <div class="c-question-block__box">
                                    <dl class="c-question-block__box__homework">
                                        <dt class="title"><span class="c-parts-label -homework-large">{{ chapter.index_label }}</span></dt>
                                        <dd class="item"><div><div><p><markdown-view :rawText="chapter.title" :souruby="accountStore.isSouruby"></markdown-view></p></div></div><div class="c-parts-text-page -homework" v-if="chapter.textbook_page_range">P {{ chapter.textbook_page_range }}</div></dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="c-accordion">
                                <input type="checkbox" value="" :id="`homework-${homework.id}-${chapter.id}`" class="c-parts-accordion-input" :name="getSentryPartAccordionName" checked>
                                <div class="c-accordion__cont c-parts-accordion-content">
                                    <template v-for="section, idx in chapter.sections">
                                        <div class="c-question-content-wrap">
                                            <div class="c-question-block__titleBox">
                                                <div class="c-question-block__box">
                                                    <dl :class="{'c-question-block__box__homework':true, '-grandchild': idx == 0, '-second': idx > 0}">
                                                        <dt class="title"><span class="c-parts-label -homework">{{ section.sort_order }}</span></dt>
                                                        <dd class="item"><div><div><p><markdown-view :rawText="section.title" :souruby="accountStore.isSouruby"></markdown-view></p></div></div><div class="c-parts-text-page -homework" v-if="section.textbook_page_range">P {{ section.textbook_page_range }}</div></dd>
                                                    </dl>
                                                </div>
                                            </div>
                                            <div class="c-question-content" v-for="question_set in section.question_sets">
                                                <div :class="{ 'c-question-content__text': true, '-complete': question_set.question_set_status >= getHomeworkProgressQuestionSetStatus.COMPLETED }" 
                                                    @click="openModal(homework.work_id, section, question_set)" :name="getSentryQsName">
                                                    <div class="c-question-content__text__inner -with-frame">
                                                        <div class="c-parts-frame-wrapper">
                                                            <span v-if="isInterruptionData(homework.work_id, question_set.id)" class="c-parts-frame -interrupt">中断した学習</span>
                                                        </div>
                                                        <div class="c-question-content__type">
                                                            <span :class="{'c-parts-frame':true, '-application': question_set.display_name == '応用問題'}" v-if="question_set.display_name">{{ question_set.display_name[0] }}</span>
                                                        </div>
                                                        <div class="c-question-content__title">
                                                            <markdown-view :rawText="question_set.title" :souruby="accountStore.isSouruby"></markdown-view>  
                                                        </div>
                                                        <div class="p-homework-items__answer-area">
                                                            <p class="p-homework-items__correct-answer">正解<span class="num">{{ question_set.number_of_correct_answers }}</span><span class="slash">/</span><span class="all">{{ question_set.number_of_questions }}</span>問</p>
                                                            <p :class="{ ['c-parts-homework-status -' + homework_status_class[question_set.question_set_status]]: true }">{{ homework_status_name[question_set.question_set_status] }}</p>
                                                        </div>
                                                        <div :class="{ 'c-parts-last-learning -homework': true, '-no-history': question_set.last_studied_at === null }">
                                                            <p class="c-parts-last-learning__history -no-star" v-if="question_set.last_studied_at !== null">
                                                                <span class="label">前回の学習</span><span class="date"><span class="num">{{ getMonth(convertDateFormat(question_set.last_studied_at)) }}</span>月<span class="num">{{ getDate(convertDateFormat(question_set.last_studied_at)) }}</span>日</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="c-accordion__btn c-parts-accordion-btn">
                                    <div class="c-accordion__btn__inner">
                                    <div class="c-accordion__btn__inner__box">
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                
            </div>
        </section>
        <!-- study interruption modal start -->
        <popup-modal v-model="interruptionModal" @close-layer="interruptionModal = false" @close="interruptionModal = false" name="interruption-btn">
            <template #main>
              <div class="c-popup-body__head">
                <p class="c-popup-body__head-title">
                  中断した学習を再開しますか？
                </p>
              </div>
              <div class="c-popup-body__titleBox">
                <div class="c-popup-body__titleBox-logout">
                  中断した学習の続きから再開することができます。
                </div>
              </div>
            </template>
            <template #footer>
              <div class="c-button -col2">
                <a @click="openQuestionModal" class="c-button-white -medium -font-large" :name="getSentryStartFromBeginning">
                  <span class="label">最初から学習</span>
                </a>
                <button-blue @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, REVIEW_REQUIRED.NOT_REVIEW_REQUIRED, true)" :medium="true" :label-normal="true" :name="getSentryResumeFromLast">続きから再開</button-blue>
              </div>
            </template>
        </popup-modal>
        <!-- Popup modal start -->
        <popup-modal v-model="isModal" @close="closeModal()" @close-layer="closeLayer()" :subject="subjectName" name="close-btn">
            <template #label><span class="c-parts-homework" v-if="isHomeworkTag(modal_question_set.question_set_status)">宿題</span></template>
            <template #main>
                <div class="c-popup-body__chapter">
                    <span class="c-parts-label -large">{{ modal_section.sort_order }}</span>
                    <div class="c-popup-body__chapter-title">
                        <markdown-view :rawText="modal_section.title" :souruby="accountStore.isSouruby"></markdown-view>
                    </div>
                </div>
                <div class="c-popup-body__titleBox">
                    <div class="c-popup-body__titleBox-title">
                        <div class="titleBlock">
                            <div class="c-parts-frame-wrapper">
                                <span v-if="modal_question_set.display_name" :class="{'c-parts-frame -question':true, '-application':modal_question_set.display_name == '応用問題'}">{{modal_question_set.display_name}}</span>
                            </div>
                            <div class="title">
                                <markdown-view :rawText="modal_question_set.title" :souruby="accountStore.isSouruby"></markdown-view>
                            </div>
                            <div class="count">全<span class="label">{{modal_question_set.number_of_questions}}</span>問</div>
                        </div>
                    </div>
                    <div class="c-popup-body__titleBox-body">
                        <div class="c-parts-text-page" v-if="modal_question_set.textbook_page_range!==''">P {{modal_question_set.textbook_page_range}}</div>
                        <div class="empty" v-else></div>
                        <div class="c-parts-last-learning -popup">
                            <p class="c-parts-last-learning__history" v-if="modal_question_set.last_studied_at !== null">
                                <span class="label">前回の学習</span>
                                <span class="date">
                                    <span class="num">{{getMonth(convertDateFormat(modal_question_set.last_studied_at))}}</span>月
                                    <span class="num">{{getDate(convertDateFormat(modal_question_set.last_studied_at))}}</span>日
                                </span>
                            </p>
                            <three-stars :number-of-stars="progressStar"></three-stars>
                        </div>
                    </div>
                    <div class="c-parts-homework-information" v-if="homeworkInfo.length !=0 && isHomeworkTag(modal_question_set.question_set_status)">
                        <div class="c-parts-homework-information-item" v-for="homework in homeworkInfo">
                            <div class="c-parts-homework-information-label">宿題</div>
                            <div class="c-parts-homework-information-limit"><span>{{ homework.month }}</span>月<span>{{ homework.day }}</span>日({{ homework.dayOfWeek }}) <span>{{ homework.time }}</span>まで</div>
                            <div class="c-parts-homework-information-status">
                                <div class="c-parts-homework-status" :class="{[homework.statusClass]: true}">{{ homework.status }}</div>
                                <div class="c-parts-pin">{{ homework.achievement }}</div>
                                <div class="c-parts-pin -row" v-if="homework.relearning">{{ homework.relearning }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <template v-if="showPopupModalButton(modal_question_set.question_set_status)">
                    <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, isReview(modal_question_set.id)?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" name="start-learning-btn">始める</button-blue>
                </template>
                <template v-else="modal_question_set.number_of_correct_answers">
                    <button-blue :full="true" @click="startLearning(STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, isReview(modal_question_set.id)?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" name="start-learning-btn">全問題を学習</button-blue>
                    <div class="c-button -col2">
                    <button-white :full="true" @click="solveUnansweredQuestion" :disabled="unansweredQuestion.length===0" name="unanswered-question-btn">
                      未正解の問題だけ学習<span class="remaining">({{unansweredQuestion.length}}問)</span>
                    </button-white>
                    <button-white :full="true" @click="solvedReviewRequired" :disabled="isReview(modal_question_set.id)===0" name="review-question-btn">
                      要復習問題だけ学習<span class="remaining">({{isReview(modal_question_set.id)}}問)</span>
                    </button-white>
                  </div>
                  <div class="btnBlock__single">
                    <a :class="{'textLink':true,'-disabled': !disabledLearning || workStore.latestQuestionHistories.length===0}"
                       @click="showQuestionHistories(isReview(modal_question_set.id)?REVIEW_REQUIRED.QUESTION_SET_REVIEW:REVIEW_REQUIRED.NOT_REVIEW_REQUIRED)" href="javascript:void(0)" name="learning-history-btn">
                      前回の学習結果を確認
                    </a>
                  </div>
                </template>
            </template>
        </popup-modal>
    </div>
</template>
  
<script setup lang="ts">
    import {ref, onMounted, computed, nextTick, watch, onUnmounted} from "vue";
    import {useRoute, useRouter} from "vue-router"
    import {event} from "vue-gtag"
    import { IHomework, IWork, IQuestion } from "@/consts/interfaces";
    import { SUBJECT_MAP } from "@/consts/subject";
    import AudioPlayer from '@/consts/sounds';
    import {STUDY_TARGET_KIND, REVIEW_REQUIRED} from "@/consts/study";
    import {HOMEWORK_PROGRESS, HOMEWORK_PROGRESS_QUESTIONSET_STATUS} from "@/consts/homework";
    import HomeworkInfo from "@/util/homework-info";
    import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env";
    import {findSectionByChapterId} from "@/util/extract-section-data"
    import { useAccountStore } from '@/store/student/account_store';
    import { useHomeworkStore } from '@/store/student/homework_store';
    import { useWorkStore } from '@/store/student/work_store';
    import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
    import { saveInitialStudyBreakData } from '@/util/study_break_data';
    import local_time from '@/util/datetime';
    import { getLatestBreakDataVersion } from '@/consts/break_data_version'
    import { createLatestQuestionHistories } from '@/util/create-lastest-qhistories';

    const props = withDefaults(
      defineProps<{
        homework: IHomework;
        isOpen?: boolean;
        isCurrent?: boolean;
        index?: number;
        numberOfHomework?: number;
      }>(),
      {
        isOpen: false,
        isCurrent: true,
        index: 0,
        numberOfHomework: 0,
      }
    );
    const audioPlayer = AudioPlayer.getInstance()
    const accountStore = useAccountStore()
    const homeworkStore = useHomeworkStore()
    const workStore = useWorkStore()
    const globalNavigationStore = useGlobalNavigationStore()

    const route = useRoute()
    const router = useRouter()
    const unansweredQuestion = ref<Array<IQuestion>>([])
    const isOpenLocal = ref(false)
    // learning popup modal flag
    const isModal = ref(false)
    const interruptionModal = ref(false)
    const modal_section = ref<any>({sort_order: null, title: ""})
    const modal_question_set = ref<any>({})
    const disabledLearning = ref(false)

    const homework_status_class = ref({1: "before", 2: "answering", 3: "complete", 4: "complete"})
    const homework_status_name = ref({1: "未解答", 2: "解答中", 3: "完了", 4: "完了"})
    const day_symbol = ref(["日", "月", "火", "水", "木", "金", "土"])
    const achievement_condition = ref({1: "1回学習しよう", 2: "全問正解しよう"})
    const refresh_timer = ref(null)
    const learningStartPage = {
      name: route.name,
      path: route.path,
      params: route.params,
    }

    onMounted(() => {
        isOpenLocal.value =  props.isOpen
        nextTick(async() => {
            // scroll into view after finish learning
            if(props.homework.id === homeworkStore.homeworkAnimationIds[props.homework.id]){
                await scrollToView()
                await showAnimation()
                homeworkStore.saveIsHomework(false)
                // delete homework_id which is already animated
                homeworkStore.deleteHomeworkAnimationId(props.homework.id)
            }
        })
    })
    const getSentryQsName = computed(() => {
        return homeworkStore.isHomeworkCurrent ? "S9-1-hw-question-set-btn" : "S9-2-hw-question-set-btn"
    })
    const getSentryPartAccordionName = computed(() => {
        return homeworkStore.isHomeworkCurrent ? "S9-1-hw-section-accordion-btn" : "S9-2-hw-section-accordion-btn"
    })
    const getSentryHwAccordionName = computed(() => {
        return homeworkStore.isHomeworkCurrent ? "S9-1-hw-accordion-btn" : "S9-2-hw-accordion-btn"
    })
    const getSentryStartFromBeginning = computed(() => {
        return homeworkStore.isHomeworkCurrent ? "S9-1-start-from-beginning-btn" : "S9-2-start-from-beginning-btn"
    })
    const getSentryResumeFromLast = computed(() => {
        return homeworkStore.isHomeworkCurrent ? "S9-1-resume-from-last-btn" : "S9-2-resume-from-last-btn"
    })
    function isInterruptionData(work_id: number, question_set_id: number):boolean {
        return workStore.study_break_data[work_id]?.break_data?.question_set_id === question_set_id
    }
    async function scrollToView(){
        return new Promise(async (resolve, reject) => {
            // scroll for expired and single question_set
            if(Object.keys(homeworkStore.homeworkAnimationIds).length === 1) {
                document.getElementById(`homeworklist-${props.homework.id}`)?.scrollIntoView({behavior: "smooth"})
            }
            else {
                if(!homeworkStore.isScrollIntoView && props.homework.homework_status >= HOMEWORK_PROGRESS.COMPLETEDWITHIN && homeworkStore.learningHomeworkStatus < HOMEWORK_PROGRESS.COMPLETEDWITHIN){
                    // find the first completed homework and scroll into view
                    homeworkStore.saveIsScrollIntoView(true)
                    document.getElementById(`homeworklist-${props.homework.id}`)?.scrollIntoView({behavior: "smooth"})
                } else if(!homeworkStore.isScrollIntoView && props.index == props.numberOfHomework){
                    // if no recently completed homework scroll to the last learning homework 
                    document.getElementById(`homeworklist-${homeworkStore.homeworkAnimationId}`)?.scrollIntoView({behavior: "smooth"})
                    homeworkStore.saveHomeworkAnimationId(0)
                }
            }
            resolve(true)
        })
    }
    async function showAnimation() {
        return new Promise((resolve, reject) =>{
            let el: HTMLElement = document.getElementById(`stamp-${props.homework.id}`)
            // show complete stamp animation of recently completed homework only for current homework page
            if(el && props.homework.homework_status >= HOMEWORK_PROGRESS.COMPLETEDWITHIN && props.isCurrent && homeworkStore.learningHomeworkStatus < HOMEWORK_PROGRESS.COMPLETEDWITHIN){
                refresh_timer.value = setTimeout(() => {
                    if(accountStore.isSoundEnabled){audioPlayer.stampSound().play()}
                    el.classList.add('is-clear')
                }, 1000)
            }
            resolve(true)
        })
    }

    const getHomeworkProgress = HOMEWORK_PROGRESS
    const getHomeworkProgressQuestionSetStatus = HOMEWORK_PROGRESS_QUESTIONSET_STATUS
    const homeworkInfo = computed(() => {
        if(modal_question_set.value.id){
            const hwInfo = new HomeworkInfo(modal_question_set.value.id, homeworkStore.homeworkQuestionSets)
            return hwInfo.info;
        }
        return [];
    })
    const progressStar = computed(() => {
      if(workStore.sectionProgress[modal_section.value.id]){
        const question_set: Array<any> = workStore.sectionProgress[modal_section.value.id].question_sets.filter(item=>{
          return item.id == modal_question_set.value.id
        })
        if(question_set.length>0 && question_set[0].latest_question_set_history){
          return question_set[0].latest_question_set_history.progress_stars
        }
      }
      return 0
    })

    // get part list from works according to homework_progress_question_set_id
    const getParts = computed(() => {
        let work: IWork[] = workStore.works.filter(w => w.id === props.homework.work_id)
        if(work.length === 0){
            return []
        }
        let qs_obj = {}
        props.homework.question_sets.forEach(qs => qs_obj[qs.id] = qs)
        let parts = []
        for(let part of work[0].parts){
            let chapters = []
            for(let chapter of part.chapters) {
                let sections = []
                for(let section of chapter.sections) {
                    let q_sets = []
                    for(let question_set of section.question_sets) {
                        if(qs_obj[question_set.id]) {
                            // collect only register question_set for homework
                            q_sets.push(
                                {
                                    id: question_set.id,
                                    question_set: question_set,
                                    display_name: question_set.question_set_label.display_name,
                                    title: question_set.title,
                                    chapter_id: qs_obj[question_set.id].chapter_id,
                                    number_of_correct_answers: qs_obj[question_set.id].number_of_correct_answers,
                                    number_of_questions: qs_obj[question_set.id].number_of_questions,
                                    last_studied_at: qs_obj[question_set.id].last_studied_at,
                                    question_set_status: qs_obj[question_set.id].question_set_status,
                                    textbook_page_range: question_set.textbook_page_range?question_set.textbook_page_range:"",
                                }
                            )
                        }
                    }
                    if(q_sets.length > 0){
                        sections.push(
                            {
                                id: section.id,
                                question_sets: q_sets,
                                title: section.title,
                                sort_order: section.sort_order,
                                textbook_page_range: section.textbook_page_range?section.textbook_page_range:""
                            }
                        )
                    }
                }
                if(sections.length > 0){
                    chapters.push({
                        id: chapter.id,
                        sections: sections,
                        title: chapter.title,
                        index_label: chapter.index_label,
                        textbook_page_range: chapter.textbook_page_range?chapter.textbook_page_range:""
                    })
                }
            }
            if(chapters.length > 0){
                parts.push({
                    id: part.id,
                    title: part.title,
                    index_label: part.index_label,
                    chapters: chapters
                })
            }
        }
        return parts
    })

    const subjectName = computed(() => {
      return workStore.workById[props.homework.work_id] ? SUBJECT_MAP[workStore.workById[props.homework.work_id].subject] : ""
    })
    const subjectFieldName = computed(() => {
      return workStore.workById[props.homework.work_id] ? workStore.workById[props.homework.work_id].subject_field: ""
    })
    const academicYear = computed(() => {
      return workStore.workById[props.homework.work_id]? workStore.workById[props.homework.work_id].academic_year: null
    })
    function playButtonSound() {
        if(accountStore.isSoundEnabled){audioPlayer.buttonSound().play()}
    }
    function getMonth(date_string: string) {
        const date = new Date(date_string)
        return date.getMonth() + 1;   
    }
    function getDate(date_string: string) {
        const date = new Date(date_string)
        return date.getDate();
    }
    function getDay(date_string: string) {
        const date = new Date(date_string)
        return day_symbol.value[date.getDay()]
    }
    function getTime(date_string: string) {
        const date = new Date(date_string)
        let hours: string | number = date.getHours()
        let minutes: string | number = date.getMinutes()
        hours = hours >= 10 ? `${hours}` : `0${hours}`
        minutes = minutes >= 10 ? `${minutes}` : `0${minutes}`
        return `${hours}:${minutes}`
    }
    function remainingTime(date_string: string) {
        const date = new Date(date_string).getTime()
        const now = new Date().getTime()
        const distance = date - now;
        let days = distance / (1000 * 60 * 60 * 24);
        if(days >= 1) {
            days = Math.round(days)
            return `あと<em class="num">${days}</em>日`
        }
        let hours = distance / (1000 * 60 * 60)
        if(hours >= 1) {
            hours = Math.floor(hours)
            return `あと<em class="num">${hours}</em>時間`
        }
        let minutes = Math.floor(distance / (1000 * 60))
        if(minutes >= 1){
            return `あと<em class="num">${minutes}</em>分`
        } else {
            return `あと<em class="num">1</em>分`
        }
    }
    
    // NFR-4232 ipadのsafariバージョンによって`-`があると日付表示がNaNになる。それを防ぐため処理追加
    function convertDateFormat(date_string: string){
        if(date_string){
            return date_string.replace(/-/g,"/")
        }
    }

    async function openModal(work_id: number,section: any, question_set: any) {
        modal_section.value = section
        modal_question_set.value = question_set
        workStore.saveSelectedQuestionSet({[question_set.id]:question_set.question_set})
        if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
        if(isInterruptionData(work_id, question_set.id)) {
            interruptionModal.value = true
        } else {
            isModal.value = true
        }
        disabledLearning.value = false
        workStore.saveIsReviewQuestion(false)
        workStore.saveIsMissionQuestion(false)
        workStore.saveIsUnanswered(false)
        workStore.saveIsPrevQuestionHistory(false)
        workStore.saveIsWronglyAnswered(false)
        globalNavigationStore.saveSelectedColor(subjectName.value)
        workStore.fetchSectionProgress({"chapter_id": question_set.chapter_id})
        await workStore.fetchQuestions({"question_set_id": question_set.id})
        const sectionData =  findSectionByChapterId(workStore.works,question_set.chapter_id)
        workStore.saveSections(sectionData)
        await workStore.fetchReviewTag({"question_set_id": question_set.id})
        await workStore.fetchLatestQuestionHistories({"question_set_id": question_set.id})
        await workStore.fetchQuestionSetProgress({question_set_ids: [question_set.id]})
        // find unanswered questions
        let questions: Array<any> = []
        for(let question of workStore.questions){
        if(!workStore.answeredQuestionIds.includes(question.id)){
            questions.push(question)
        }
        }
        workStore.saveTotalNumOfQuestion(workStore.questions.length)
        unansweredQuestion.value = questions
        disabledLearning.value = true
    }
    function openQuestionModal(){
        interruptionModal.value = false
        isModal.value = true
    }
    function closeModal() {
        if(!disabledLearning.value){
            return
        }
        if(accountStore.isSoundEnabled){audioPlayer.closeSound().play()}
        isModal.value = false
    }
    function closeLayer(){
        if(!disabledLearning.value){
            return
        }
        isModal.value = false
    }
    async function solveUnansweredQuestion(){
        workStore.saveIsUnanswered(true)
        workStore.saveIsWronglyAnswered(false)
        let question_ids:Array<number> = []
        if(unansweredQuestion.value.length>15){
            for(let i=0; i<10; i++){
                question_ids.push(unansweredQuestion.value[i].id)
            }
            workStore.saveQuestions(unansweredQuestion.value.splice(0, 10))
        }else{
            unansweredQuestion.value.forEach(question => question_ids.push(question.id))
            workStore.saveQuestions(unansweredQuestion.value)
        }
        workStore.saveQuestionIds(question_ids)
        workStore.saveTotalNumOfQuestion(unansweredQuestion.value.length)
        startLearning(STUDY_TARGET_KIND.LEARN_UNANSWERED_QUESTIONS)
    }
    async function solvedReviewRequired(){
        workStore.saveIsReviewQuestion(true)
        let questions: Array<any> = []
        let question_ids: Array<number> = []
        workStore.reviewTags.forEach(review => {
            if(review.question.question_set_id == modal_question_set.value.id){
                questions.push(review.question)
                question_ids.push(review.question.id)
            }
        })
        if(questions.length>0){
            workStore.saveQuestions(questions)
            workStore.saveQuestionIds(question_ids)
            workStore.saveTotalNumOfQuestion(question_ids.length)
            startLearning(STUDY_TARGET_KIND.LEARN_REVIEW_REQUIRED_QUESTIONS, REVIEW_REQUIRED.QUESTION_SET_REVIEW)
        }
    }
    async function startLearning(study_target_kind:number=STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS, review_kind:number=REVIEW_REQUIRED.NOT_REVIEW_REQUIRED, isInterrupt=false){
        if(!disabledLearning.value){
            return
        }
        workStore.saveQIdx(0)
        const hwInfo = new HomeworkInfo(modal_question_set.value.id, homeworkStore.homeworkQuestionSets)
        homeworkStore.saveHomeworkAnimationIds(hwInfo.homework_ids(props.homework.id))
        homeworkStore.saveHomeworkAnimationId(props.homework.id)
        workStore.saveIsLearningPage(true)
        workStore.saveIsLearningMode(true)
        workStore.saveLearningStartPage(learningStartPage)
        workStore.saveSelectedWorkIndex(0)
        // to track learning start from homework page
        homeworkStore.saveIsHomework(true)
        // save current learning homework status for show completed stamp animation
        homeworkStore.saveLearningHomeworkStatus(props.homework.homework_status)
        workStore.saveSelectedWork(workStore.works.filter(w => w.id == props.homework.work_id))
        if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
        let questionCorrectWrongList = workStore.questionIds.map((item) => {
            return {
            result: null,
            progress: 0
            }
        })
        workStore.fetchQuestionProgress({question_ids: workStore.questionIds})
        workStore.initializeAnswer()
        workStore.saveNextQuestionSet(null)
        if(isEnvCaptureGoogleAnalyticsEvents()){
            event('start_study', {
                'subject_field': subjectFieldName.value,
                'study_target_kind': study_target_kind,
                'review_kind': review_kind,
                'work_id': workStore.selectedWork[workStore.selectedWorkIndex]?.id,
                'target_question_count': questionCorrectWrongList.length
            })
        }
        if(isInterrupt){
            // NFR-5868: getting the interruption data
            const break_data = workStore.study_break_data[workStore.selectedWorkId]?.break_data
            workStore.saveIsWronglyAnswered(true)
            questionCorrectWrongList = break_data?.correct_wrong_list
            // NFR-5868: ensure to save initialAnswer as an array
            workStore.saveInitializeAnswer(break_data?.saved_answers || [])
            // NFR-5456: getting interruption question index
            const current_question_index = break_data?.interrupt_index
            // NFR-5456: getting the last interrupt path
            const interrupt_path = break_data?.interrupt_path
            workStore.saveQIdx(current_question_index)
            const created_at = break_data?.data_created_at
            const updated_at = local_time()
            study_target_kind = break_data?.study_target
            // NFR-5679 initialAnswerの長さがquestionsの長さと一致しない場合には該当するquestionsを取得して再保存処理を行う。
            if(workStore.initialAnswer.length !== workStore.questions.length){
                const initial_question_ids = workStore.initialAnswer.map(answer=> answer.question_id)
                const filtered_questions = workStore.questions.filter(question => initial_question_ids.includes(question.id))
                workStore.saveQuestionIds(initial_question_ids)
                workStore.saveQuestions(filtered_questions)
            }
            // NFR-5456: initilize study break data when resume learning
            saveInitialStudyBreakData(workStore, modal_question_set.value.id, questionCorrectWrongList, created_at, updated_at, null, getLatestBreakDataVersion(), study_target_kind, current_question_index)
            workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
            // 中断して再開する時が未正解問題を解くの場合
            if(study_target_kind && study_target_kind === STUDY_TARGET_KIND.LEARN_UNANSWERED_QUESTIONS){
                // NFR-5679 study_targetが未正解問題を解くの場合はis_unanswered stateをtrueに変更する（S3-10結果画面の数字が正しく表示するため）
                workStore.saveIsUnanswered(true)
                // NFR-5442 中断して再開する時、正答済みの解答欄はDBに保存しないようにする。（S3-10の誤答のみ解くと同じ仕様にする）
                workStore.initialAnswer.forEach(answer => {
                    answer.quiz_histories.forEach(quiz => {
                        quiz.is_first_correct_answer = quiz.is_correct_answer;
                    });
                });
            }
            router.push({name:`${interrupt_path}`})
        } else {
            workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
            // NFR-5456: initilize study break data
            saveInitialStudyBreakData(workStore, modal_question_set.value.id, questionCorrectWrongList, local_time(), null, null, getLatestBreakDataVersion(), study_target_kind)
            router.push({name:'question'})
        }
    }

    async function showQuestionHistories(review_kind:number){
        if(disabledLearning.value == false || workStore.latestQuestionHistories.length == 0){
            return
        }
        if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
        // initialize all question answer
        workStore.initializeAnswer()
        workStore.saveIsDisabledButton(false)
        workStore.saveIsLearningPage(true)
        workStore.saveIsLearningMode(true)
        workStore.saveQIdx(0)
        workStore.saveIsPrevQuestionHistory(true)
        workStore.saveLearningStartPage(learningStartPage)
        workStore.saveSelectedWorkIndex(0)
        // save current learning homework_id for scroll last learning when go back to homework page
        homeworkStore.saveHomeworkAnimationIds({[props.homework.id]: props.homework.id})
        homeworkStore.saveHomeworkAnimationId(props.homework.id)
        workStore.saveSelectedWork(workStore.works.filter(w => w.id == props.homework.work_id))
        const questionCorrectWrongList = createLatestQuestionHistories();
        if(isEnvCaptureGoogleAnalyticsEvents()){
          event('start_study', {
            'subject_field': subjectFieldName.value,
            'study_target_kind': STUDY_TARGET_KIND.CHECK_RESULT_PREVIOUS_STUDY,
            'review_kind': review_kind,
            'work_id': workStore.selectedWork[workStore.selectedWorkIndex]?.id,
            'target_question_count': questionCorrectWrongList.length
        })
        }
        // reset router transit time for history check
        workStore.saveTransitTime(0)
        router.push({name:'answer'})
    }

    function open() {
      homeworkStore.saveHomeworkAccordion({id: props.homework.id, value: isOpenLocal.value})
    }

    function isHomeworkTag(status: number) {
        if(status === HOMEWORK_PROGRESS_QUESTIONSET_STATUS.COMPLETED || !props.isCurrent){
            return false
        }
        return true
    }

    function showPopupModalButton(status: number){
        if(status === HOMEWORK_PROGRESS_QUESTIONSET_STATUS.NOTSTARTED){
            return true
        }
        return false
    }

    function isReview(qs_id: number){
        return workStore.reviewTags.filter(item => item.question.question_set_id == qs_id).length
    }

    watch(
      () => props.isOpen,
      () => {
        isOpenLocal.value = props.isOpen
      }
    )

    onUnmounted(() => {
      clearTimeout(refresh_timer.value)
    })
</script>
  